// Names of the labox-conversions errors raised for inputs it cannot compute, as the alcoholometry
// API returns them ({ name, message }).
const CALCULATION_ERRORS = [
  'INDEX_OUT_OF_BOUNDS_ERROR',
  'HEADER_OUT_OF_BOUNDS_ERROR',
  'NOT_FOUND_ERROR',
  'VALUE_ERROR',
  'SOLVE_ERROR',
  'NULL_VALUE_ERROR',
];

export default function isCalculationError(parsedError) {
  return Boolean(parsedError) && CALCULATION_ERRORS.includes(parsedError.name);
}
